import { useNavigate } from 'react-router-dom';
import { Sheet, SheetContent, SheetTitle, SheetDescription } from './ui/sheet';
import { useCart } from '../context/CartContext';
import { Minus, Plus, X } from 'lucide-react';

const CartSlideOver = () => {
  const navigate = useNavigate();
  const { cart, isCartOpen, setIsCartOpen, removeFromCart, updateQuantity, getCartTotal } = useCart();

  const handleCheckout = () => { setIsCartOpen(false); navigate('/cart'); };

  return (
    <Sheet open={isCartOpen} onOpenChange={setIsCartOpen}>
      <SheetContent className="w-full sm:max-w-lg bg-bb-black border-l border-bb-border p-0 flex flex-col">
        <SheetDescription className="sr-only">Shopping bag contents</SheetDescription>
        <div className="p-6 border-b border-bb-border">
          <SheetTitle className="font-heading text-xl c-cream tracking-wider">Your Bag ({cart.length})</SheetTitle>
        </div>
        {cart.length === 0 ? (
          <div className="flex-grow flex flex-col items-center justify-center p-8 text-center">
            <p className="font-heading text-2xl c-cream mb-4">Your bag is empty</p>
            <p className="t-body c-muted mb-8 text-sm">Explore our collection of premium bee products</p>
            <button onClick={() => { setIsCartOpen(false); navigate('/products'); }} className="btn-outline" data-testid="cart-shop-button">Shop Now</button>
          </div>
        ) : (
          <>
            <div className="flex-grow overflow-y-auto p-6 space-y-6">
              {cart.map((item, i) => (
                <div key={`${item.product_id}-${item.state}`} className="flex gap-4" data-testid={`cart-item-${i}`}>
                  <div className="w-20 h-24 flex-shrink-0 bg-bb-rich overflow-hidden">
                    <img src={item.image_url} alt={item.name} className="w-full h-full object-cover" />
                  </div>
                  <div className="flex-grow">
                    <div className="flex justify-between items-start mb-1">
                      <div>
                        <h4 className="font-heading text-base c-cream">{item.name}</h4>
                        <div className="flex items-center gap-2 mt-1">
                          <span className={item.state === 'California' ? 'dot-ca' : 'dot-az'} />
                          <span className="t-label text-[9px] c-muted">{item.state}</span>
                        </div>
                      </div>
                      <button onClick={() => removeFromCart(item.product_id, item.state)} className="c-muted hover:c-cream transition-colors" data-testid={`cart-remove-${i}`}>
                        <X className="w-4 h-4" />
                      </button>
                    </div>
                    <div className="flex items-center justify-between mt-3">
                      <div className="flex items-center gap-3">
                        <button onClick={() => updateQuantity(item.product_id, item.state, item.quantity - 1)} className="w-7 h-7 border border-bb-dim flex items-center justify-center c-muted hover:border-bb-gold transition-colors" data-testid={`cart-decrease-${i}`}><Minus className="w-3 h-3" /></button>
                        <span className="t-body text-sm c-cream w-6 text-center">{item.quantity}</span>
                        <button onClick={() => updateQuantity(item.product_id, item.state, item.quantity + 1)} className="w-7 h-7 border border-bb-dim flex items-center justify-center c-muted hover:border-bb-gold transition-colors" data-testid={`cart-increase-${i}`}><Plus className="w-3 h-3" /></button>
                      </div>
                      <span className="font-heading text-base c-cream">${(item.price * item.quantity).toFixed(2)}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-bb-border p-6 space-y-4">
              <div className="flex justify-between items-center">
                <span className="t-label c-muted">Subtotal</span>
                <span className="font-heading text-xl c-cream">${getCartTotal().toFixed(2)}</span>
              </div>
              <p className="t-label text-[9px] c-muted">Shipping calculated at checkout</p>
              <button onClick={handleCheckout} className="btn-primary w-full" data-testid="cart-checkout-button">Proceed to Checkout</button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};

export default CartSlideOver;
